import _ from 'lodash';

import alt from '../alt';


class NotificationActions {
    showInfo(uuid, message, extra) {
        this.actions.__showLevel('info', uuid, message, extra);
    }

    showSuccess(uuid, message, extra) {
        this.actions.__showLevel('success', uuid, message, extra);
    }

    showWarning(uuid, message, extra) {
        this.actions.__showLevel('warning', uuid, message, extra);
    }

    showError(uuid, message, extra) {
        this.actions.__showLevel('error', uuid, message, extra);
    }

    __showLevel(level, uuid, message, extra) {
        if (level && uuid && message) {
            this.dispatch(_.extend({
                level,
                uuid,
                message
            }, extra || {}));
        } else {
            console.error('ERROR: NotificationActions.__showLevel, all params are required!');
        }
    }

    showLoader(uuid, message) {
        if (uuid && message) {
            this.dispatch({
                uuid,
                message
            });
        } else {
            console.error('ERROR: NotificationActions.showLoader, all params are required!');
        }
    }

    hideNotification(uuid) {
        this.dispatch({
            uuid
        });
    }

    hideNotifications(startsWith) {
        this.dispatch({
            startsWith
        });
    }

    /**
     * Called by the react-notification-system when notification is removed by it instead of our code.constructor
     * We use this to remove that notification from our store
     *
     * @param notification
     * @private
     */
    __removeNotification(notification) {
        this.dispatch(notification);
    }
}

export default alt.createActions(NotificationActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/NotificationActions.js
 **/